export const name = 'gzSpinner';

/**
 * @ngdoc directive
 * @name gazelle.components.spinner.directive:gzSpinner
 *
 * @param {boolean=} if-loading specifies the model property to watch to determine when to show the spinner.
 * @param {number=} md-diameter specifies the diameter of the circular progress.  Default: 48
 *
 * @description
 * `<gz-spinner>` is a widget that will display a spinner until promises are resolved and data is ready. If the value passed to if-loading is true then
 * the spinner is visable. If it is false then the spinner is hidden.  If nothing is passed to if-loading then gz-spinner will attempt to use the 26A convetional
 * property (isLoading) for a loading situation.  Controllers should define the isLoading property to indicate if it is still waiting in a promise.
 * Either way, the value is watched and will cause the spinner to appear (true) or the spinner to be hidden (false).
 *
 * @usage
 * ```html
 * <div>
 *   <gz-spinner if-loading='vm.isLoading'></gz-spinner>
 *   <span> Content shows here when it is resolved</span>
 * </div>
 * ```
 */
export default function gzSpinner($log) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'EA',
    scope: {
      ifLoading: '=',
      diameter: '@',
      mode: '@',
    },
    template: require('./spinner.jade'),
    link: gzSpinnerLink,
  };

  return directive;


  //////////////////////
  // Private functions

  function gzSpinnerLink(scope, element, attrs) {
    // If the developer didn't pass in an if-loading='something' attribute then look for
    // the "standard" loading flag on the parent.
    if ((scope.ifLoading === undefined) && (_.get(scope, '$parent.vm.isLoading', undefined) !== undefined)) {
      let unregister = scope.$parent.$watch('vm.isLoading', function(newVal, oldVal) {
        scope.ifLoading = newVal;
        if (!newVal) { unregister(); }
        // $log.debug('scope.isLoading changed to ' + newVal);
      });
    }

    if(scope.diameter === undefined) {
      // MD default
      scope.diameter = 50;
    }

    if(scope.mode === undefined) {
      // MD default
      scope.mode = 'circle';
    }
  }
} //gzSpinner
